export default "__VITE_ASSET__lUj2I9vf__"